module.exports = __webpack_public_path__ + "img/goods-1.cd9a1037.png";